import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as FieldComponents from "@Shared/components/sections/index";
import SimpleButton from "@Shared/components/buttons/simple-button.vue";
import ApplicationAutomationStatistics from "./application-automation-statistics";
import UpcomingRecipientsModal from "./upcoming-recipients-modal";
import CampaignSubjectSection from "../../../../../modules/marketing/components/campaigns/campaign-subject-section";
import CampaignDesignSection from "../../../../../modules/marketing/components/campaigns/campaign-design-section";
import TemplateCard from "@Broker/@Modules/marketing/templates/components/template-card.vue";
import AppAutomationDetailsLoader from "./app-automation-details-loader";
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import { mapActions, mapMutations } from "vuex";
import { DOWNLOAD_CAMPAIGN_RESULTS } from "../../../../marketing/store/marketing/marketing-actions";
import { CREATE_APPLICATION_AUTOMATION, UPDATE_APPLICATION_AUTOMATION, LOAD_APPLICATION_AUTOMATIONS, LOAD_AUTOMATION_STATISTICS } from "../../store/automation-actions";
import { SET_AUTOMATION_SUBJECT_DATA, SET_AUTOMATION_TEMPLATE_DATA, CLEAR_AUTOMATION_ROUTE_PARAMS } from "../../store/automation-mutations";
import { ACCOUNT_PLAN_PAGE } from "@Broker/@Utils/enum";
import PlanSimpleButton from "@Broker/@Modules/account-plan/components/account-plan-usage/plan-simple-button.vue";
import { every, isEmpty } from "lodash";
import { v4 as uuidv4 } from "uuid";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "ApplicationAutomationSingleDetails",
  components: _objectSpread(_objectSpread({}, FieldComponents), {}, {
    UpcomingRecipientsModal,
    CampaignSubjectSection,
    CampaignDesignSection,
    AppAutomationDetailsLoader,
    TemplateCard,
    ApplicationAutomationStatistics,
    SimpleButton,
    PlanSimpleButton
  }),
  mixins: [validationMixin],
  validations: {
    subjectData: {
      subject: {
        required
      },
      previewText: {
        required,
        maxLength: maxLength(255)
      }
    },
    templateData: {
      templateId: {
        required
      }
    }
  },
  props: {
    automation: {
      type: Object,
      required: true
    },
    time: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      localSubjectData: {
        subject: "",
        previewText: ""
      },
      editedSubjectData: {
        subject: "",
        previewText: ""
      },
      editedTemplateData: {
        templateId: "",
        templateName: "",
        templateThumbnail: ""
      },
      editMode: false,
      downloadingCsv: {
        loading: false,
        status: true
      },
      submittingAutomation: {
        loading: false,
        status: true
      },
      loadingStatistics: true,
      coappHandler: this.automation["trigger-arguments"].coappHandler || {
        enabled: false,
        value: false
      },
      labelFor: uuidv4()
    };
  },
  computed: {
    simpleButtonComponent() {
      return this.editMode ? SimpleButton : PlanSimpleButton;
    },
    currentAccountPlanPage() {
      return ACCOUNT_PLAN_PAGE.APPLICATION_LEVEL_AUTOMATION;
    },
    emptyAutomationDetails() {
      return !this.automation["action-arguments"].campaignId;
    },
    actionArguments() {
      return this.automation["action-arguments"];
    },
    templateData() {
      if (this.editMode) return this.editedTemplateData;
      return {
        templateId: this.actionArguments.templateId,
        templateName: this.actionArguments.templateName,
        templateThumbnail: this.actionArguments.templateThumbnail
      };
    },
    subjectData() {
      if (this.editMode) return this.editedSubjectData;
      const {
        subject = "",
        previewText = ""
      } = this.actionArguments;
      return {
        subject,
        previewText
      };
    },
    statistics() {
      return this.actionArguments.statistics;
    },
    isValid() {
      return !this.$v.$invalid;
    },
    selectTemplateParams() {
      return {
        query: {
          backPath: "/automation/automations/application",
          fromAutomation: true,
          automationId: this.automation.id,
          trigger: this.automation.trigger,
          editMode: this.editMode,
          previewText: this.subjectData.previewText,
          subject: this.subjectData.subject
        }
      };
    },
    loadingTemplate() {
      const {
        templateData
      } = this.$route.params;
      return isEmpty(templateData) && isEmpty(this.templateData);
    }
  },
  watch: {
    editMode(value) {
      if (value === false) {
        this.editedSubjectData = this.subjectData;
        this.editedTemplateData = this.templateData;
      }
    },
    actionArguments(value) {
      if (value.campaignId && (!value.recipients || !value.statistics)) {
        this.initAutomationAdditionalData();
      }
    },
    templateData(value, oldValue) {
      if (every(oldValue, isEmpty)) this.editedTemplateData = value;
    }
  },
  mounted() {
    if (this.actionArguments.campaignId) {
      this.initAutomationAdditionalData();
    }
    const {
      templateData: passedTemplateData,
      openAutomation: paramOpenAutomation,
      editMode: paramEditMode,
      subjectData: passedSubjectData
    } = this.$route.params;
    const openAutomation = _parseInt(paramOpenAutomation);
    const passedEditMode = paramEditMode === "true";
    this.editMode = passedEditMode != null ? passedEditMode : this.editMode;
    const subjectDataToUse = passedSubjectData || this.subjectData;
    this.localSubjectData = subjectDataToUse;
    this.editedSubjectData = subjectDataToUse;
    this.editedTemplateData = passedTemplateData || this.templateData;
    if (openAutomation && openAutomation == this.automation.id && !this.editMode) {
      this.SET_AUTOMATION_TEMPLATE_DATA({
        templateData: passedTemplateData,
        automationId: openAutomation
      });
    }
    this.CLEAR_AUTOMATION_ROUTE_PARAMS(this.$route);
  },
  methods: _objectSpread(_objectSpread(_objectSpread(_objectSpread({}, mapActions("AutomationStore", [LOAD_APPLICATION_AUTOMATIONS, CREATE_APPLICATION_AUTOMATION, UPDATE_APPLICATION_AUTOMATION, LOAD_AUTOMATION_STATISTICS])), mapActions("MarketingStore", [DOWNLOAD_CAMPAIGN_RESULTS])), mapMutations("AutomationStore", [SET_AUTOMATION_SUBJECT_DATA, SET_AUTOMATION_TEMPLATE_DATA, CLEAR_AUTOMATION_ROUTE_PARAMS])), {}, {
    async initAutomationAdditionalData() {
      await this.LOAD_AUTOMATION_STATISTICS({
        automation: this.automation
      });
      this.loadingStatistics = false;
    },
    async downloadCsv() {
      try {
        this.downloadingCsv.loading = true;
        await this.DOWNLOAD_CAMPAIGN_RESULTS({
          campaignId: this.actionArguments.campaignId
        });
      } catch (e) {
        this.downloadingCsv.status = false;
      } finally {
        this.downloadingCsv.loading = false;
      }
    },
    handleChangeSubject({
      subject,
      previewText
    }) {
      const newData = {
        subject,
        previewText
      };
      if (this.editMode) {
        this.editedSubjectData = newData;
      } else {
        this.localSubjectData = newData;
        this.SET_AUTOMATION_SUBJECT_DATA({
          automationId: this.automation.id,
          subjectData: this.localSubjectData
        });
      }
    },
    handleSubmit() {
      if (this.editMode) {
        this.localSubjectData = this.editedSubjectData;
        this.SET_AUTOMATION_SUBJECT_DATA({
          automationId: this.automation.id,
          subjectData: this.editedSubjectData
        });
        this.SET_AUTOMATION_TEMPLATE_DATA({
          templateData: this.editedTemplateData,
          automationId: this.automation.id
        });
        this.editAppAutomation();
      } else this.createAppAutomation();
    },
    async editAppAutomation() {
      try {
        this.submittingAutomation.loading = true;
        await this.UPDATE_APPLICATION_AUTOMATION({
          automation: _objectSpread(_objectSpread({}, this.automation), {}, {
            "action-arguments": _objectSpread(_objectSpread({}, this.automation["action-arguments"]), {}, {
              coappHandler: this.coappHandler
            })
          })
        });
        this.editMode = false;
      } catch (e) {
        this.submittingAutomation.status = false;
      } finally {
        this.submittingAutomation.loading = false;
      }
    },
    async createAppAutomation() {
      try {
        this.submittingAutomation.loading = true;
        await this.CREATE_APPLICATION_AUTOMATION({
          automation: _objectSpread(_objectSpread({}, this.automation), {}, {
            "action-arguments": _objectSpread(_objectSpread({}, this.automation["action-arguments"]), {}, {
              coappHandler: this.coappHandler
            })
          })
        });
      } catch (e) {
        this.submittingAutomation.status = false;
      } finally {
        this.submittingAutomation.loading = false;
      }
    },
    toggleEditMode() {
      this.editMode = !this.editMode;
    },
    handleViewRecipients() {
      this.$refs.upcomingRecipientsModal.show();
    },
    handleToggleIncludeCoapps(save) {
      if (save) {
        this.submittingAutomation.loading = true;
        this.editAppAutomation();
      }
    }
  })
});